// extracted by mini-css-extract-plugin
export default {"highlight":"highlight_highlight__Y-qMm","topBorder":"highlight_topBorder__Rdc1M"};